module.exports = __webpack_public_path__ + "img/284c05a0ac6a4bb0b218e66de606844b-1024.6c30d8ed.jpg";